import type { TimelineEvent } from '../../../patient-files/actions/types';
import type { FinalReviewSection } from '../../../../services/finalReview';
import { sectionOf } from '../design-dx/handBackNotes.ts';

// Mirrors HAND_BACK_EVENT_TYPE in backend final-review.validator.ts.
export const HAND_BACK_EVENT_TYPE = 'design.final-review.handed-back';

export interface PastFeedbackNote {
    section: FinalReviewSection;
    text: string;
}

export interface PastFeedbackRound {
    id: string;
    round: number;
    author: string;
    at: string;
    notes: PastFeedbackNote[];
}

function isStoredNote(value: unknown): value is { section: string; text: string } {
    if (typeof value !== 'object' || value === null) return false;
    const { section, text } = value as Record<string, unknown>;
    return typeof section === 'string' && typeof text === 'string';
}

function notesOf(payload: Record<string, unknown>): PastFeedbackNote[] {
    const notes: unknown[] = Array.isArray(payload.notes) ? payload.notes : [];
    return notes.filter(isStoredNote).map((n) => ({ section: sectionOf(n.section), text: n.text }));
}

// Newest first; round 1 is the oldest hand-back. `total` counts past the fetch cap.
export function pastFeedbackRounds(
    events: readonly TimelineEvent[],
    total: number
): PastFeedbackRound[] {
    const newestFirst = [...events].sort((a, b) => b.createdAt.localeCompare(a.createdAt));
    return newestFirst.map((e, i) => ({
        id: e.id,
        round: total - i,
        author: e.createdByUser?.name ?? e.createdBy,
        at: e.createdAt,
        notes: notesOf(e.payload)
    }));
}
